import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const SeleccionarCandidato = ({
  onClose,
  open,
  mostrarAlertaTemporal,
  obtenerCandidatos,
  id_candidato,
}) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const SeleccionarCandidatoUpdate = async () => {
    try {
      const response = await fetch(
        `${UrlApi}/SP_candidatos/seleccionarCandidato`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id_candidato: id_candidato }),
        }
      );

      if (!response.ok) {
        const data = await response.json();
        const errorMessage =
          data.message || "Hubo un error al seleccionar el candidato";
        mostrarAlertaTemporal(errorMessage, "error");
        return;
      }

      mostrarAlertaTemporal(
        "El candidato ha sido seleccionado correctamente",
        "success"
      );

      await obtenerCandidatos();
    } catch (error) {
      console.error("hubo un error al mandar la solicutud", error);
      mostrarAlertaTemporal("Server was busy, Try again later", "error");
    }
    logEventos(
      "Aprobando/Desaprobando candidatos",
      "Candidatos",
      "Selecciono un candidatos para la solicitud",
      localStorage.getItem("user")
    );

    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
    >
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              Seleccionar candidato
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          ¿Esta seguro que quiere seleccionar el candidato? Asegurese que cuente
          con evaluaciones medicas y entrevistas y ambas esten aprobadas cambio
            {/* ¿Esta seguro que quiere seleccionar el candidato? Asegurese que cuente
          con  entrevistas  aprobadas */}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={onClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={SeleccionarCandidatoUpdate}
            variant="contained"
            color="primary"
          >
           Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default SeleccionarCandidato;
